import { ApiReactiveService } from '@composable-api/service/api.reactive-service'
import type { ApiModel } from '@composable-api/api.model'
import type { ApiServiceFetchOptions } from '@composable-api/service/api.service'
import { CartModel } from '@simploshop-models/cart.model'
import { toValue } from 'vue'
import type { MaybeRefOrGetter } from 'vue'

class CartCustomerAccountsApiService<M extends ApiModel> extends ApiReactiveService<M> {
    post(data: { customer_account_id: number, amount: number }, options?: ApiServiceFetchOptions<M>) {
        return this.fetch({
            ...options,
            method: 'POST',
            body: data,
        })
    }

    delete(options?: ApiServiceFetchOptions<M>) {
        return this.fetch({
            ...options,
            method: 'DELETE',
        })
    }
}

export function useCartCustomerAccountsApiService(options: {
    cartId: MaybeRefOrGetter<string | null | undefined>
}) {
    return new CartCustomerAccountsApiService({
        endpoint: () => `/carts/${toValue(options.cartId)}/customer-accounts`,
    }, CartModel)
}
